import React from "react";
import { Box, Flex, Text, SimpleGrid, Icon } from "@chakra-ui/react";
import { FaShieldAlt, FaTruck, FaUndo, FaHeadset } from "react-icons/fa";

function BeforeFooter() {
  const highlights = [
    {
      icon: FaShieldAlt,
      title: "100% Authentic Legal Literature",
      desc: "All law books, commentaries, and journals directly sourced from reputed publishers.",
    },
    {
      icon: FaTruck,
      title: "Nationwide Express Delivery",
      desc: "Safe doorstep delivery across all court complexes, offices, and universities in India.",
    },
    {
      icon: FaUndo,
      title: "Easy 10-Day Return Guarantee",
      desc: "Hassle-free return policy if there are any printing defects or binding issues.",
    },
    {
      icon: FaHeadset,
      title: "Dedicated Legal Desk Support",
      desc: "Reach our customer assistance team for title availability, custom quotes & bulk inquiries.",
    },
  ];

  return (
    <Box bg="#FFFFFF" borderTop="1px solid #E2E8F0" py="10" px={{ base: "4", md: "8" }}>
      <Box maxW="1360px" mx="auto">
        {/* Value Highlights */}
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing="6" mb="8">
          {highlights.map((item, idx) => (
            <Flex
              key={idx}
              align="flex-start"
              gap="3.5"
              p="4"
              rounded="xl"
              bg="#F8FAFC"
              border="1px solid #F1F5F9"
            >
              <Box p="2.5" rounded="lg" bg="white" color="#2563EB" shadow="sm">
                <Icon as={item.icon} boxSize="20px" />
              </Box>
              <Box>
                <Text fontSize="14px" fontWeight="700" color="gray.900">
                  {item.title}
                </Text>
                <Text fontSize="12px" color="gray.500" mt="1" lineHeight="1.4">
                  {item.desc}
                </Text>
              </Box>
            </Flex>
          ))}
        </SimpleGrid>

        {/* SEO Editorial text */}
        <Box
          p="5"
          rounded="xl"
          bg="#F8FAFC"
          border="1px solid #E2E8F0"
          fontSize="12.5px"
          color="gray.600"
          lineHeight="1.6"
        >
          <Text fontSize="14px" fontWeight="700" color="gray.800" mb="2">
            Navneet Law Studios: India’s Premier Legal Marketplace & AI Tech Suite
          </Text>
          <Text mb="2">
            Navneet Law Studios is revolutionizing how law practitioners, judicial officers, students, and legal scholars access authoritative books and modern cloud software in India. We house everything from constitutional commentaries, civil and criminal manuals, bare acts with latest amendments, and specialized tax journals, to cutting-edge AI legal research tools like Supreme Today AI, CDJ Law Journal, and Legit Quest.
          </Text>
          <Text>
            Enjoy secure cashless transactions via credit/debit cards, net banking, and UPI with comprehensive GST invoicing for all purchases.
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default BeforeFooter;